import { listFormTemplates } from '@wix/ambassador-forms-v1-form-template-http/http';
import { convertToAddressTemplates } from '@wix/form-fields/controller';
import { withCancelToken } from '@wix/form-http-essentials';
import { ADDRESS_FORM_ID_BY_COUNTRY } from '@wix/form-multiline-address';
import { FORM_PLATFORM_NAMESPACE } from '../constants/namespaces';
import { overrideTemplateFieldIds } from './address-forms-overrides';
export const fetchAddressForms = async (httpClient, errorHandler, signal)=>{
    try {
        const res = await errorHandler.withErrorHandler(()=>httpClient.request(withCancelToken(listFormTemplates({
                templateIds: [
                    ...new Set(Object.values(ADDRESS_FORM_ID_BY_COUNTRY))
                ],
                namespace: FORM_PLATFORM_NAMESPACE
            }), signal, httpClient)), {
            errorCodesMap: {}
        });
        return convertToAddressTemplates(overrideTemplateFieldIds(res.data.templates ?? []));
    } catch (error) {
        errorHandler.showError(error);
        throw error;
    }
};

//# sourceMappingURL=fetch-address-forms.js.map